// extracted by mini-css-extract-plugin
module.exports = {"container":"layout-module--container--zLeA4","content":"layout-module--content--2CPz1"};